/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import Vue from 'vue';
import IssuesMoment from '@/plugins/moment';
import IssuesToastr from '@/plugins/toastr';
import IssuesDebounce from '@/plugins/debounce';

/**
 * Plugins entry point.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
// register toastr plugin
Vue.use(IssuesToastr, {
    options: {
        closeButton: true,
        debug: false,
        newestOnTop: false,
        progressBar: false,
        positionClass: 'toast-bottom-right',
        preventDuplicates: false,
        onclick: undefined,
        showDuration: 300,
        hideDuration: 600,
        timeOut: 10000,
        extendedTimeOut: 1000,
        showEasing: 'swing',
        hideEasing: 'linear',
        showMethod: 'fadeIn',
        hideMethod: 'fadeOut',
    },
});


// register moment plugin
Vue.use(IssuesMoment);

// register debounce plugin
Vue.use(IssuesDebounce);
